import { render, staticRenderFns } from "./HandleCourseStudentStatus.vue?vue&type=template&id=11bf4e14&"
import script from "./HandleCourseStudentStatus.vue?vue&type=script&lang=ts&"
export * from "./HandleCourseStudentStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports